"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminalConnectionTokenSchema = exports.terminalPaymentPreparationSchema = exports.terminalPaymentSessionSchema = exports.terminalPaymentStatusSchema = exports.createTerminalPaymentRequestSchema = exports.terminalPaymentReadinessSchema = void 0;
const zod_1 = require("zod");
exports.terminalPaymentReadinessSchema = zod_1.z.object({
    available: zod_1.z.boolean(),
    reason: zod_1.z.string().max(240).nullable(),
    invoiceId: zod_1.z.uuid().nullable(),
    invoiceNumber: zod_1.z.number().int().positive().nullable(),
    amountCents: zod_1.z.number().int().nonnegative(),
    currency: zod_1.z.literal("USD"),
    environment: zod_1.z.enum(["SANDBOX", "LIVE"]).nullable(),
});
exports.createTerminalPaymentRequestSchema = zod_1.z
    .object({
    idempotencyKey: zod_1.z.uuid(),
})
    .strict();
exports.terminalPaymentStatusSchema = zod_1.z.enum([
    "ACTIVE",
    "PROCESSING",
    "SUCCEEDED",
    "FAILED",
    "CANCELED",
    "EXPIRED",
    "REQUIRES_REVIEW",
]);
exports.terminalPaymentSessionSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    invoiceId: zod_1.z.uuid(),
    amountCents: zod_1.z.number().int().positive(),
    currency: zod_1.z.literal("USD"),
    status: exports.terminalPaymentStatusSchema,
    environment: zod_1.z.enum(["SANDBOX", "LIVE"]),
});
// SDK credentials are returned only by authenticated, no-store POST endpoints.
exports.terminalPaymentPreparationSchema = exports.terminalPaymentSessionSchema.extend({
    clientSecret: zod_1.z.string().min(1).max(512),
    readerLocationId: zod_1.z.string().min(1).max(255),
    simulated: zod_1.z.boolean(),
});
exports.terminalConnectionTokenSchema = zod_1.z.object({
    secret: zod_1.z.string().min(1).max(1024),
});
//# sourceMappingURL=terminal-payment.js.map